import React from 'react';

import { H2, Small, Text } from '../Typography';

import Image from './Error.svg';

import styles from './Error.module.scss';

export type ErrorFallbackProps = {
    children?: React.ReactNode;
    eventId: string;
    header: string;
    message: React.ReactNode;
};

export const Error = ({ children, eventId, header, message }: ErrorFallbackProps) => {
    return (
        <div className={styles.container}>
            <img alt="" className={styles.image} src={Image} />
            <H2 className={styles.header}>{header}</H2>
            <Text as="p" className={styles.message}>
                {message}
            </Text>
            <Small className={styles.code}>{eventId}</Small>
            {children}
        </div>
    );
};

Error.displayName = 'Error';
